/**
 * @file 链接
 * @author (zhanghao14)
 */
import Link from './Link.js';
export default Link;